<template>
  <div
    @mouseover="mouseOverModifyStatus($event)"
    @mouseleave="mouseLeaveModifyStatus($event)"
    style="height: 50px"
  >
    <el-tag size="mini" effect="light">{{ bookingStatus }}</el-tag>

    <el-dropdown
      @command="handleCommand"
      @visible-change="visible_change"
      trigger="click"
    >
      <span
        v-show="showModifyStatus"
        class="status_modify_button"
        :underline="false"
        icon="el-icon-d-caret"
      >
        <i class="el-icon-d-caret el-icon--right"></i>改状态
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="WAIT_ACCEPT" icon="el-icon-unlock"
          >未处理</el-dropdown-item
        >
        <el-dropdown-item command="CHANGE" icon="el-icon-edit"
          >需要修改</el-dropdown-item
        >
        <el-dropdown-item command="CANCELED" icon="el-icon-close"
          >已取消</el-dropdown-item
        >
        <el-dropdown-item command="CONFIRM" icon="el-icon-finished"
          >订单已确认</el-dropdown-item
        >
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
export default {
  name: "button-drop-down",
  data() {
    return {
      showModifyStatus: false,
      bookingStatus: this.tagData,
      dropDownShow: null,
    };
  },
  props: {
    tagData: String,
    bookingID: Number,
    otaId: String,
  },
  watch: {
    tagData(newDate) {
      this.bookingStatus = newDate;
    },
  },
  methods: {
    handleCommand(command) {
      let data_change_status = {
        status: command,
        booking_id: this.bookingID,
        ota_id: this.otaId,
      };
      this.$http.post("/booking/status", data_change_status).then((res) => {
        console.log(res);
        const { errno, errmsg, new_status } = res.data;
        if (errno == "0") {
          this.$message({
            message: errmsg,
            type: "success",
          });
          this.bookingStatus = new_status;
        }
      });
    },
    mouseOverModifyStatus(event) {
      this.showModifyStatusButtom();
    },
    mouseLeaveModifyStatus() {
      // 判断下拉菜单是否显示true，如果显示ture则不隐藏，否则隐藏
      if (this.dropDownShow == true) {
        this.showModifyStatus = true;
      } else {
        this.showModifyStatus = false;
      }
    },
    showModifyStatusButtom() {
      this.showModifyStatus = true;
    },
    visible_change(value) {
      if (value == true) {
        this.dropDownShow = true;
        return value;
      } else if (value == false) {
        this.dropDownShow = false;
        this.showModifyStatus = false;
      }
    },
  },
};
</script>

<style>
.status_modify_button {
  /* font-size: 0.1rem; */
  font-size: 11px;
  cursor: pointer;
}
</style>